import React from 'react';
import { Order as RiderOrder } from '../../services/ordersService';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';2

interface RiderOrderHistoryTabProps {
  orderHistory: RiderOrder[];
}

const RiderOrderHistoryTab: React.FC<RiderOrderHistoryTabProps> = ({ orderHistory }) => {
  const formatDate = (dateString?: string | null) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN');
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Recent Orders
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Order ID</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Client ID</TableCell>
                <TableCell>Client Name</TableCell>
                <TableCell>City</TableCell>
                <TableCell align="right">Orders</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
                {orderHistory.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} sx={{ textAlign: 'center', py: 4 }}>
                    No orders found
                  </TableCell>
                </TableRow>
              ) : (
                orderHistory.map((order) => (
                  <TableRow key={order.id}>
                    <TableCell>{order.id.slice(0, 8)}...</TableCell>
                    <TableCell>{formatDate(order.date)}</TableCell>
                    <TableCell>{order.clientId || '-'}</TableCell>
                    <TableCell>{order.clientName || '-'}</TableCell>
                    <TableCell>{order.city || '-'}</TableCell>
                    <TableCell align="right">{typeof order.totalOrdersDay === 'number' ? order.totalOrdersDay : 'N/A'}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default RiderOrderHistoryTab;
